import { geometry, drawing } from '@progress/kendo-drawing';
import { defined } from '../utils/functions.js';
import { deepExtend } from '../utils/deep-extend.js';
import { AutoSizeableMixin } from './AutoSizeableMixin.js';
import { VisualBase } from './VisualBase.js';

class Circle extends VisualBase {
    constructor(options) {
        super(options);
        // Bind mixin methods to current instance
        this._setScale = AutoSizeableMixin._setScale.bind(this);
        this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
        this._initSize = AutoSizeableMixin._initSize.bind(this);
        this._updateSize = AutoSizeableMixin._updateSize.bind(this);
        this._initCircle();
        this._initSize();
    }
    redraw(options) {
        if (options) {
            const circleOptions = this.options;
            if (options.center) {
                deepExtend(circleOptions, {
                    center: options.center
                });
                this._center.move(circleOptions.center.x, circleOptions.center.y);
            }
            if (this._diffNumericOptions(options, ['radius'])) {
                this._circle.setRadius(circleOptions.radius);
            }
            this._updateSize(options);
            super.redraw.call(this, options);
        }
    }
    _initCircle() {
        const options = this.options;
        let width = options.width;
        let height = options.height;
        let radius = options.radius;
        if (!defined(radius)) {
            if (!defined(width)) {
                width = height;
            }
            if (!defined(height)) {
                height = width;
            }
            options.radius = radius = Math.min(width, height) / 2;
        }
        const center = options.center || { x: radius, y: radius };
        this._center = new geometry.Point(center.x, center.y);
        this._circle = new geometry.Circle(this._center, radius);
        this.drawingElement = new drawing.Circle(this._circle, {
            stroke: options.stroke
        });
        this._fill();
    }
}

export { Circle };
